import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const config = {
  position: toast.POSITION.BOTTOM_RIGHT,
  autoClose: 3000,
  pauseOnFocusLoss: false,
  hideProgressBar: true
}

export default class ToastHelper {
  static success(message) {
    toast.success(message, config);
  }

  static error(message) {
    toast.error(message, config);
  }

  static message(message, options = {}) {
    let cuzOptions = Object.assign({}, config, options)
    switch (message.status) {
      case 'success':
        toast.success(message.message, cuzOptions);
        break;
      case 'error':
        toast.error(message.message, cuzOptions);
        break;
      case 'warning':
        toast.warning(message.message, cuzOptions);
        break;
      default:
        break
    }
  }
}
